export default __webpack_public_path__ + "static/media/NuleepWhyModel.98b11b86.svg";